import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CompaniesIntegrationsService } from '../companiesintegrations.service';

@Component({
  selector: 'app-integration-edit-webcrm',
  templateUrl: './integration-edit-webcrm.component.html',
  styleUrls: ['./integration-edit-webcrm.component.scss']
})
export class IntegrationEditWebcrmComponent implements OnInit {

  /*
    - Organizaciones: sin acceso / lectura / lectura y escritura
    - Contactos: sin acceso / lectura / lectura y escritura
    - Actividades: sin acceso / lectura / lectura y escritura
  */

    public permissions: any = [
      {name:"Sin acceso", value:""},
      {name:"Lectura", value:"read"},
      {name:"Lectura y escritura", value:"readwrite"}
    ];

  public integration: any = {
    configuration: {}
  };

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private companiesIntegrationsService: CompaniesIntegrationsService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.companiesIntegrationsService.getByCode("webcrm").subscribe(
      data => {
        if (data != null) {
          if (data.configuration == null) data.configuration = {};
          this.integration = data;
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  save() {
    //const md5 = new Md5();
    //obj.configuration.password = md5.appendStr(obj.configuration.password).end();
    this.companiesIntegrationsService.save(this.integration.id, this.integration).subscribe(
      data => {
        this.dynamicDialogRef.close();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
